import React, { PureComponent } from "react";

import Condition from "./Condition";
import styles from "./Filter.local.scss";
import _ from "i18n";

export default class FilterComponent extends PureComponent {
  state = {
    nbRows:
      this.props.conditions.length === 0 ? 1 : this.props.conditions.length,
    selectedOption: null
  };

  addRow = e => {
    this.setState({ nbRows: this.state.nbRows + 1 });
  };
  minusRow = e => {
    this.setState({ nbRows: this.state.nbRows - 1 });
  };

  render() {
    const { type, order, conditions } = this.props;
    const { nbRows } = this.state;

    let rows = [];
    for (let i = 0; i < nbRows; i++) {
      rows.push(
        <Condition
          key={`condition-${i}`}
          type={type}
          order={order}
          cpt={i}
          condition={conditions && conditions[i] ? conditions[i] : null}
          nbRows={nbRows}
          addRow={this.addRow}
          minusRow={this.minusRow}
        />
      );
    }

    return (
      <div className={styles.filters}>
        <h4>{_("Dispay conditions")}</h4>
        <div className={styles.rule}>
          {_("if")}
          <select className={styles.filled}>
            <option value="AND">{_("All conditions")}</option>
            <option value="OR" disabled>
              {_("Some conditions")}
            </option>
          </select>
          {_("Are applied")}
        </div>
        <ul>{rows}</ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/Filter/FilterComponent.js